import app from "@cms/core/app";
import { httpClientIntegration } from "@sentry/browser";
import * as Sentry from "@sentry/vue";
import { useConfigStore } from "@verbleif/shared/src/composables/ConfigStore/useConfigStore";
import router from "./router";

if (import.meta.env.PROD) {
  const configStore = useConfigStore();
  Sentry.init({
    app,
    dsn: "https://abbc36bdc72342ec8e147b91e97edc62@sentry.vitrion.dev/36",
    environment: configStore.config.value?.appEnv,
    integrations: [
      httpClientIntegration(),
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
        },
      }),
    ],
    sendDefaultPii: true,
    // The API reports to its own Sentry server. Sending the trace along gives an API error the same trace id as
    // the browser error, so `trace:<id>` finds both. Needs `sentry-trace` and `baggage` in the API's CORS allow list.
    tracePropagationTargets: [
      "cms.verbleif.dev",
      "cms.verbleif.com",
      "cms.staging.verbleif.com",
      /^https:\/\/api\.(staging\.)?verbleif\.(com|dev)\//,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0.2,
  });
}
